import mk from 'mirrorkey';

export default mk(['NPO', 'LOCATION']);



// WEBPACK FOOTER //
// ./src/enums/dndTypes.js